export const anonymousUser = {
  firstName: 'Anonymous',
  lastName: 'User',
  email: 'anonymoususer@solidcad.ca',
  isAnonymous: true,
};
